import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check } from 'lucide-react';
export function IncludesSection() {
  const items = ['El Tablero 4Z paso a paso (lo construyes en 45 min)', 'Zona 1 Mañanas: salida en 12 minutos + estación anti-pérdidas', 'Zona 2 Tardes: snack fijo + aterrizaje + tareas sin guerra', 'Zona 3 Noches: Rotación 5 + cena de emergencia + cierre 8 min', 'Zona 4 Emergencias: Día Mínimo + guiones + recuperación en 24h', 'La regla "1 cosa menos" (recortar sin culpa)', 'Guiones para escuela / trabajo / familia (corto, claro, repetible)', 'Plan de implementación de 14 días'];
  return <section className="py-20 px-4 bg-white" data-id="element-76">
      <div className="max-w-4xl mx-auto" data-id="element-77">
        <FadeIn className="text-center mb-12" data-id="element-78">
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900" data-id="element-79">
            Lo que incluye el PDF
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-x-12 gap-y-6" data-id="element-80">
          {items.map((item, index) => <FadeIn key={index} delay={index * 0.05} data-id="element-81">
              <div className="flex items-start p-4 rounded-xl hover:bg-[#FDF8F3] transition-colors" data-id="element-82">
                <div className="bg-[#C75B3F]/10 p-2 rounded-full mr-4 flex-shrink-0" data-id="element-83">
                  <Check className="w-5 h-5 text-[#C75B3F]" data-id="element-84" />
                </div>
                <span className="text-lg text-stone-700 font-medium pt-1" data-id="element-85">
                  {item}
                </span>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}